import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import { useDispatch } from 'react-redux';
import { addItem } from './redux/actions/assettable.action';
import palettle from '../../../theme/palette';

const AssetCheckTable = (props) => {
  const { getItems, readOnly } = props;
  //props
  const dispatch = useDispatch();
  // const [submit, setsubmit] = useState(false);
  const [items, setItems] = useState([]);
  const [columns] = useState([
    {
      title: 'assetCode',
      field: 'assetCode',
      editable: 'never',
    },
    {
      title: 'assetDescription',
      field: 'assetDescription',
      editable: 'never',
      cellStyle: {
        width: '30%',
      },
    },
    {
      title: 'serial',
      field: 'serial',
      editable: 'never',
      cellStyle: {
        width: '20%',
      },
    },
    {
      title: 'isMatching',
      field: 'isMatching',
      // field: 'quanitity',
      editable: 'never',
    },
    {
      title: 'currentOwner',
      field: 'currentOwner',
      editable: 'never',
      cellStyle: { width: '0%' },
    },
    {
      title: 'quanitity',
      field: 'quanitity',
      type: 'numeric',
      editable: 'never',
      cellStyle: {
        width: '50%',
      },
    },

    {
      title: 'remark',
      field: 'remark',
      editable: 'onUpdate',
      cellStyle: {
        width: '120%',
      },
    },
  ]);

  useEffect(() => {
    // setItems(...items, getItems);
    setItems((prev) => [...prev, ...getItems]);
  }, [getItems]);

  useEffect(() => {
    dispatch(addItem(items));
    return () => {
      //dispatch(clearItem());
    };
  }, [items]);

  return (
    <>
      <div id="materialTable">
        <MaterialTable
          title="Asset Check List"
          columns={columns}
          data={items}
          options={{
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: palettle.background.default,
              color: palettle.primary.main,
            },
          }}
          editable={
            !readOnly
              ? {
                  onRowUpdate: (newData, oldData) =>
                    new Promise((resolve, reject) => {
                      setTimeout(() => {
                        const dataUpdate = [...items];
                        const index = oldData.tableData.id;
                        dataUpdate[index] = newData;
                        setItems([...dataUpdate]);
                        resolve(items);
                      }, 200);
                    }),
                  onRowDelete: (oldData) =>
                    new Promise((resolve, reject) => {
                      setTimeout(() => {
                        const dataDelete = [...items];
                        const index = oldData.tableData.id;
                        dataDelete.splice(index, 1);
                        setItems([...dataDelete]);
                        resolve();
                      }, 200);
                    }),
                }
              : {}
          }
        />
      </div>
    </>
  );
};

export default AssetCheckTable;
